import back5 from "../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";
import Cards from "./listing";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const ListingGROAdmin = () => {
  const router = useNavigate();
  const location = useLocation();
  const dash = location.pathname;
  const dataUser = useSelector((state) => state.dataUser);
  const user = useSelector((state) => state.user);

  return (
    <div className="flex items-center justify-center pt-[2rem] flex-col">
      <div
        className={`${
          user === "merchant-owner" ? "sm:w-[90%] w-full" : "sm:w-[80%] w-full"
        }  flex flex-col items-center justify-center`}
      >
        <div className="w-full flex items-center justify-between">
          <div className="flex justify-between w-full pl-1 pr-1 items-center mt-4">
            <div
              onClick={() => {
                if (user === "merchant-owner")
                  router("/MerchantDashBoard/events");
                else if (user === "pensioner")
                  router("/PensionerDashBoard/events");
                else router("/EmployeeDashBoard/events");
              }}
              className="cursor-pointer flex items-center justify-center"
            >
              <img className="sm:w-[1.7rem] w-[1.3rem]" src={back5} alt="" />
              <h2 className="font-bold sm:text-[1.8rem] sm:ml-2 ml-[1rem] text-[1.4rem]">
                Saved Events
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${
          user === "merchant-owner" ? "sm:w-[90%] w-full" : "sm:w-[80%] w-full"
        } p-2`}
      >
        <Cards />
      </div>
    </div>
  );
};

export default ListingGROAdmin;
